module.exports = __webpack_public_path__ + "site/img/244.dc933258.jpg";